"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Icon = require("../Icon");
var _CheckboxModule = _interopRequireDefault(require("./Checkbox.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/*
  Note: An indeterminate state has a higher priority.
  If true checkbox would be in an indeterminate state. If indeterminate is false, it will owner checked value.
*/

const Checkbox = exports.Checkbox = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    name = 'checkbox',
    value = '',
    children,
    checked = false,
    indeterminate = false,
    focused = false,
    disabled = false,
    error = false,
    onChange,
    align,
    classNames,
    tabIndex = 0,
    ariaLabel = '',
    testId
  } = _ref;
  const checkboxInput = /*#__PURE__*/React.createRef();
  React.useImperativeHandle(forwardRef, () => checkboxInput.current);
  const handleOnClick = event => {
    if (!disabled) {
      onChange?.({
        value,
        checked: !checked
      }, event);
    }
  };
  React.useEffect(() => {
    if (checkboxInput.current && focused) {
      checkboxInput.current.focus();
    }
  }, [focused]);
  React.useEffect(() => {
    if (checkboxInput.current && indeterminate) {
      checkboxInput.current.indeterminate = true;
    }
    if (checkboxInput.current && !indeterminate) {
      checkboxInput.current.indeterminate = false;
    }
  }, [indeterminate]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'root'
    }),
    className: (0, _classify.default)(_CheckboxModule.default.checkboxContainer, {
      [_CheckboxModule.default.disabled]: disabled,
      [_CheckboxModule.default.horizontalCheckbox]: align === 'horizontal-fixed',
      [_CheckboxModule.default.fluidCheckbox]: align === 'horizontal-fluid'
    }, classNames?.wrapper),
    onClick: handleOnClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: (0, _classify.default)(_CheckboxModule.default.checkboxSquare, {
        [_CheckboxModule.default.disabled]: disabled
      }, classNames?.checkboxSquare),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'square'
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        tabIndex: disabled ? -1 : tabIndex,
        type: "checkbox",
        checked: checked,
        readOnly: true,
        ref: checkboxInput,
        className: (0, _classify.default)(_CheckboxModule.default.inputCheckbox),
        disabled: disabled,
        name: name,
        "aria-label": ariaLabel || children,
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'input'
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: (0, _classify.default)(_CheckboxModule.default.checkboxSquareInner, {
          [_CheckboxModule.default.enabled]: !disabled && !error,
          [_CheckboxModule.default.disabled]: disabled,
          [_CheckboxModule.default.error]: error && !disabled
        }),
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'inner'
        }),
        children: [indeterminate && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          color: disabled ? 'disabled' : 'inversePrimary',
          name: "hyphen",
          size: "small",
          type: "regular",
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'indeterminate-icon'
          })
        }), checked && !indeterminate && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          color: disabled ? 'disabled' : 'inversePrimary',
          name: "check",
          size: "small",
          type: "regular",
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'check-icon'
          })
        })]
      })]
    }), React.Children.count(children) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_CheckboxModule.default.checkboxLabel, {
        [_CheckboxModule.default.labelDisabled]: disabled
      }, classNames?.label),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'label'
      }),
      children: children
    })]
  });
});